/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Utils\TableFormat.ts
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Thursday June 8th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday, 26th September 2023 05:20:56
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { TableCell } from "@mui/material";
import translator from "MultiLanguage/TranslationWrapper";
import { languagePairMatchType } from "Type/languagePairMatchType";

class TableUtils{
    // static buildObjectTable(item: any, theads: (string | JSX.Element)[], correspondance: languagePairMatchType) {
    //     let myRet: languagePairMatchType = {};
    //     let itemKeys: string[] = Object.keys(item);
    //     for (let i = 0; i < theads.length; ++i){
    //         if (typeof theads[i] == "string") {
    //             myRet[translator.decode(theads[i])] = correspondance[theads[i]] in item ? item[correspondance[theads[i]]] : "";
    //         }
    //         if (itemKeys.includes(correspondance[theads[i]]))
    //             itemKeys.splice(itemKeys.indexOf(correspondance[theads[i]]), 1);
    //     }
    //     for (let key of itemKeys)
    //         myRet[key] = item[key];
    //     return myRet;
    // }

    static createHeaderTableRows(Headers: (string | JSX.Element)[]) {
        let myHeader: JSX.Element[] = [];
        for (let i = 0; i < Headers.length; ++i)
            myHeader.push(<TableCell style={{minWidth:`${100/Headers.length}%`, fontWeight: "bold"}} key={`${Headers[i]}-${i}`}> {Headers[i]} </TableCell> );
        return myHeader;
    }

    static FormatTableHeader(headerArray: (string | JSX.Element)[], key: string) {
        let myRet: (string | JSX.Element)[] = [];
        for (let i = 0; i < headerArray.length; ++i)
            if (typeof headerArray[i] == 'string')
                myRet.push(key + headerArray[i]);
            else
                myRet.push(headerArray[i]);
        return myRet;
    }

    static FormatCorrespondance(key: (string | JSX.Element)[], value: (string | JSX.Element)[]) {
        let myRet: languagePairMatchType = {};
        for (let i = 0; i < key.length; ++i)
            if (typeof key === "string")
                myRet[key[i]] = value[i];
            else
                myRet[""] = value[i];
        return myRet;
    }

    static initForCarrierArray(keys: number[]) {
        const myHeader = this.createHeaderTableRows(keys.map(val => val.toString()));
        const correspondance = keys.map((key, idx) => {return {key: key.toString(), val: keys[idx].toString()}});
        return {header: myHeader, correspondance};
    }

    static initFormatRowCreateHeader(keys: (string | JSX.Element)[], translateKey: string) {
        const Headers: (string | JSX.Element)[] = keys.map((val: (string | JSX.Element)) => typeof val == 'string' ? (val  !== "" ? translator.decode(`${translateKey}${val}`) : "") : val);
        const myHeader = this.createHeaderTableRows(Headers);
        const correspondance = Headers.map((key, idx) => {return {key: key.toString(), val: keys[idx].toString()}} );
        return {header: myHeader, dataForRows:{keys, Headers, correspondance}};
    }

    static Spliting(number?: number) {
        if (number)
            return number.toLocaleString("FR-fr");
        else
            return number;
    }

};

export default TableUtils;
